<template>
  <div id="registerBaseInfo">
    <div class="main-container" v-loading="this.loading" element-loading-text="加载中">
      
      <!--基本信息-->
      <div id="inforView" class="pt15">
        <el-form class="el-form demo-form-inline" ref="baseInforForm" :model="baseInforForm" label-width="150px" label-position="right" :rules="baseInforRules">
          <el-row class="mb5" style="border-bottom:1px solid #2452ff;line-height: 29px;">
            <el-col :span="24">
              <strong style="color: #2452ff;">注册账号信息</strong>
            </el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="username" label="用户名手机号">
                <el-input size="small" v-model="baseInforForm.username" placeholder="用户名手机号" @change="usnameChange()">
                  <el-button id="usname-btn" :disabled=usnameBtnDisable slot="append" @click="getUserNameMsgCode()" v-text=unMsgCodeText></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item prop="messageCode" label="短信验证码">
                <el-input size="small" v-model="baseInforForm.messageCode" placeholder="短信验证码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="password" label="密码">
                <el-input size="small" v-model="baseInforForm.password" placeholder="密码" type="password"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item prop="password2" label="确认密码">
                <el-input size="small" v-model="baseInforForm.password2" placeholder="确认密码" type="password"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="REAunscid" label="统一社会信用代码">
                <el-input size="small" v-model="baseInforForm.REAunscid" placeholder="统一社会信用代码" @blur="tyshxydmCheck"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            
          </el-row>


          <el-row class="mb5" style="border-bottom:1px solid #2452ff;line-height: 29px;">
            <el-col :span="24">
              <strong style="color: #2452ff;">企业基本信息</strong>
            </el-col>
          </el-row>
        
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="zwgsmc" label="中文公司名称">
                <el-input size="small" v-model="baseInforForm.zwgsmc" placeholder="中文公司名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item prop="gsjc" label="公司简称">
                <el-input size="small" v-model="baseInforForm.gsjc" placeholder="公司简称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="ywgsmc" label="英文公司名称">
                <el-input size="small" v-model="baseInforForm.ywgsmc" placeholder="英文公司名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item prop="ywgsjc" label="英文公司简称">
                <el-input size="small" v-model="baseInforForm.ywgsjc" placeholder="英文公司简称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="xzqh" label="合同邮寄地址">
                <el-cascader id="ShengShiCascader" :options="xzqhDataTree" :props="defaultProps" size="small" v-model="baseInforForm.xzqh" placeholder="省/市" class="searchSelect" clearable show-all-levels></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item prop="yjdzxx" label="合同邮寄详细地址">
                <el-input size="small" v-model="baseInforForm.yjdzxx" placeholder="合同邮寄详细地址"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="bgdh" label="办公电话">
                <el-input size="small" v-model="baseInforForm.bgdh" maxlength="50" placeholder="办公电话" style="width:70%;float:left"></el-input>
                <div style="width:5%;display:inline;float:left;text-align: center">
                  <p style="font-size: 14px;color: #606266;line-height: 40px;">-</p>
                </div>
                <el-input size="small" v-model="baseInforForm.bgdhfjh" maxlength="50" placeholder="分机号" style="width:25%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item prop="dzyx1" label="密码找回邮箱">
                <el-input size="small" v-model="baseInforForm.dzyx1" placeholder="密码找回邮箱" @change="dzyxChange()">
                  <el-button id="mail-btn" :disabled=mailBtnDisable slot="append" @click="openYxYz" v-text=mailCodeText></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="lxr" label="联系人">
                <el-input size="small" v-model="baseInforForm.lxr" placeholder="联系人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item prop="lxrsj" label="手机">
                <el-input disabled size="small" v-model="baseInforForm.lxrsj" placeholder="手机">
                  <el-button slot="append" @click="openSjYz">修改</el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="frdb" label="备用联系人">
                <el-input size="small" v-model="baseInforForm.frdb" placeholder="备用联系人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              
              <el-form-item prop="frdbdh" label="备用联系人手机">
                <el-input size="small" v-model="baseInforForm.frdbdh" placeholder="备用联系人手机"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="wz" label="网址">
                <el-input size="small" v-model="baseInforForm.wz" placeholder="网址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
           
            <el-col :span="11">
              <span style="color:red">提示：备用联系人不能和联系人是同一人，将用在出差、休假等情况下，展会事宜的联系</span>
            </el-col>
          </el-row>
          
          <el-row class="buttonSubmit">
            <el-col :span="24">
              <el-button type="primary" size="small" class="btn_submit" @click="submitJbxx('baseInforForm')">完成注册&nbsp;
                <i class="el-icon-check"></i>
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!--手机验证dialog-->
      <el-dialog title="手机号码验证" :visible.sync="dialogSjFormVisible" @close="closeDialog()" :close-on-click-modal="false" :append-to-body="true">
        <el-form class="el-form demo-form-inline" ref="sjform" :model="sjform" label-position="right" label-width="120px" :rules="sjformRules">
          <el-row class="tr mb5">
            <el-col :span="22">
              <el-form-item prop="sjh" label="手机号">
                <el-input size="small" v-model="sjform.sjh" placeholder="手机号">
                  <el-button id="mobile-btn" slot="append" @click="getMessageCode()" v-text=messageCodeText :disabled=mobileBtnDisable></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="22">
              <el-form-item prop="yzm" label="短信验证码">
                <el-input size="small" v-model="sjform.yzm" placeholder="短信验证码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="closeDialog(sjform)">取消</el-button>
          <el-button size="small" type="primary" @click.native="sjformSubmit(sjform)">提交</el-button>
        </div>
      </el-dialog>
      <!--邮箱验证dialog-->
      <el-dialog title="邮箱验证" :visible.sync="dialogYxFormVisible" @close="closeYxDialog()" :close-on-click-modal="false" :append-to-body="true">
        <el-form class="el-form demo-form-inline" ref="yxform" :model="yxform" label-width="120px" label-position="right">
          <el-row class="tr mb5" style="text-align: left;margin-left: 10px">
            请输入邮箱
            <span v-text="this.baseInforForm.dzyx1" style="font-style:italic;margin-right: 2px;"></span>收到的验证码
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="22">
              <el-form-item prop="yzm" label="验证码">
                <el-input size="small" v-model="yxform.yzm" placeholder="验证码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="closeYxDialog()">取消</el-button>
          <el-button size="small" type="primary" @click.native="yxformSubmit()">提交</el-button>
        </div>
      </el-dialog>

      <!--准备材料弹窗-->
      <el-dialog title="提示" :visible.sync="tipsDialogVisible"  width="40%" center append-to-body >
        <div style="font-size:18px">
          <li>您已完成账号注册，请通过注册账号的手机号登录系统进行报名。</li><br/>
          <li>报名信息包括：企业开票信息、企业其他信息、企业其他信息（二）、企业和产品介绍、本届展会报名信息。</li><br/>
          <li>您需要准备：营业执照图片、开票信息、企业logo图片、企业介绍、至少两张产品图片及产品介绍。</li>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeTipsDialog()">确 定</el-button>
        </span>
      </el-dialog>
      
    </div>
  </div>
</template>

<script>
export default {
  props:{
    // username:{
    //   type:String,
    //   required:true
    // },
    // password:{
    //   type:String,
    //   required:true
    // },
    // REAunscid:{
    //   type:String,
    //   required:true
    // },
    // messageCode:{
    //   type:String,
    //   required:true
    // },
  },
  name: "registerBaseInfo",
  data() {
    return {
      //当前用户
      //currentUser: this.CONSTANT.currentUser,
      baseUrl: window.config.baseUrl,
      myHeaders: { XTOKEN: localStorage.getItem("XTOKEN") },
      //上传图片路径配置
      yyzzUploadAction :window.config.domain+'/qyjbxx/upload',
      //显示加载中样
      loading: false,    
      //要删除的图片路径list
      delPicList: [],
      delPicSrc: "",
      //上传后未保存的图片list
      unsavedPicList: [],
      //基本信息表单
      baseInforForm: {
        //add by yushch 260825 合并两个注册。提交时验证短信码，防止恶意注册
        username: "",
        messageCode:"",
        password:"",
        password2:"",
        REAunscid:"",
        //end add yushch 260825
        // 统一社会信用代码查重标识（已被注册时为 true）
        tyshxydmAlertFlag2: false,
        zwgsmc: "",
        ywgsmc: "",
        frdb: "",
        frdbdh: "",
        yjdzsheng: "",
        yjdzshi: "",
        yjdzxx: "",
        bgdh: "",
        bgdhfjh:"",
        cz: "",
        lxr: "",
        lxrsj: "",
        wz: "",
        dzyx: "",
        dzyx1: "",
        yyzzgs: "",
        gsjc:"",
        ywgsjc:""
      },
      //手机验证表单显示标识
      dialogSjFormVisible: false,
      //邮箱表单显示标识
      dialogYxFormVisible: false,
      //邮箱验证flag
      mailCheck: false,
      //邮箱验证按钮可用flag
      mailBtnDisable: false,
      //手机验证按钮可用flag
      mobileBtnDisable: false,
      //上传的文件为pdf标识
      isPdf: false,
      //是否为已驳回的申请
      isYbh: false,

      //通过验证的邮箱地址（记录以防验证后修改邮箱）
      checkedMailAddress: "",
      //短信验证按钮文字
      messageCodeText: "获取验证码",
      //短信验证码
      messageCodeReal: "",
      //邮箱验证码
      mailCodeReal: "",
      //邮箱验证按钮文字
      mailCodeText: "验证",
      time: 60,
      timer: null,
      time2: 60,
      timer2: null,
      
      //行政区划tree
      xzqhDataTree: [],
      //树结构配置
      defaultProps: {
        children: "children",
        label: "codeName",
        value: "codeValue"
      },
      //上传图片Data
      fileList: [],
      //上传加参数
      upLoadData: {
        qyid: ""
      },
      //曾用公司名称
      cygsmc: "",
      //手机验证表单
      sjform: {
        sjh: "",
        yzm: ""
      },
      yxform: {
        yzm: ""
      },
      baseInforRules: {
        username:[
          { required: true, message: "请输入用户名手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确格式的手机号",
            trigger: "blur"
          },
        ],

        zwgsmc: [
          { required: true, message: "请输入中文公司名称", trigger: "blur" },
          { min: 1, max: 100, message: "最多可输入100个字", trigger: "blur" }
        ],
        ywgsmc: [
          { required: true, message: "请输入英文公司名称", trigger: "blur" },
          /*
          {
            pattern: /^[a-z\d\.\,\，\|\-\(\)\'\!\<\>\_\*\&\（\） ]+$/i,
            message: "英文公司名称只能输入字母、空格、括号和 .,-|",
            trigger: "blur"
          },*/
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('请输入英文字符'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' },
          { min: 1, max: 100, message: "最多可输入100个字符", trigger: "blur" }
        ],
        xzqh: [
          { required: true, message: "请选择合同邮寄地址省市", trigger: "change" }
        ],
        yjdzxx: [
          { required: true, message: "请输入合同邮寄详细地址", trigger: "blur" },
          { min: 1, max: 100, message: "最多可输入100个字", trigger: "blur" }
        ],
        bgdh: [
          { required: true, message: "请输入办公电话", trigger: "blur" },
          { min: 1, max: 25, message: "最多可输入25个字", trigger: "blur" }
          ],
        frdb: [
          { required: true, message: "请输入备用联系人", trigger: "blur" },
          { min: 1, max: 25, message: "最多可输入25个字", trigger: "blur" }
        ],
        frdbdh: [
          { required: true, message: "请输入备用联系人手机", trigger: "blur" },
        //  { pattern: /^[0-9]*$/, message: "只能输入数字", trigger: "blur" },
          { min: 1, max: 15, message: "最多可输入15个字", trigger: "blur" },

        ],
        cz: [
        //  { pattern: /^[0-9]*$/, message: "只能输入数字", trigger: "blur" },
          { min: 1, max: 30, message: "最多可输入30个字", trigger: "blur" }
        ],
        lxr: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          { min: 1, max: 25, message: "最多可输入25个字", trigger: "blur" }
        ],
        lxrsj: [
          { required: true, message: "请输入联系人手机号码", trigger: "blur" },
        //  { pattern: /^[0-9]*$/, message: "只能输入数字", trigger: "blur" },
          { min: 1, max: 15, message: "最多输入15个字", trigger: "blur" }
        ],
        wz: [
          { required: false, message: "请输入网址", trigger: "blur" },
          { min: 1, max: 100, message: "最多可输入100个字", trigger: "blur" }
        ],
        dzyx1: [
          { required: true, message: "请输入密码找回邮箱", trigger: "blur" },
        /*  {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          },
        */
       /*   {
            pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@[0-9A-Za-z]+(?:\.[0-9A-Za-z]+)+$/,
            message: "仅支持数字和字母组合的邮箱地址，最多可连续出现一个连接符",
            trigger: "blur"
          },*/
          { min: 1, max: 30, message: "最多输入30个字符", trigger: "blur" }
        ],
        gsjc:[
          { required: true, message: "请输入公司简称", trigger: "blur" },
          { min: 1, max: 4, message: "最多输入4个字", trigger: "blur" }
        ],
        ywgsjc: [
          { required: true, message: "请输入英文公司简称", trigger: "blur" },
          { pattern: /^[^\s]*$/, message: "最多输入一个单词", trigger: "blur" },
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('请输入英文字符'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' }
        ],
        // 密码：8-30 位，必须同时包含字母和数字（与父组件 Register.vue 校验保持一致）
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 8, max: 30, message: "密码长度需为 8-30 位", trigger: "blur" },
          {
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,30}$/,
            message: "密码需同时包含字母和数字",
            trigger: "blur"
          }
        ],
        // 确认密码：必填且与密码一致
        password2: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value && value !== this.baseInforForm.password) {
                callback(new Error("两次输入的密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        // 统一社会信用代码：18 位，由数字和大写字母组成（不含 I、O、S、V、Z）
        REAunscid: [
          { required: true, message: "请输入统一社会信用代码", trigger: "blur" },
          {
            pattern: /^[0-9A-HJ-NP-RTUWXY]{2}\d{6}[0-9A-HJ-NP-RTUWXY]{10}$/,
            message: "统一社会信用代码格式不正确",
            trigger: "blur"
          },
          { 
            validator: (rule, value, callback) => {
              if (this.tyshxydmAlertFlag2) {
                callback(new Error("统一社会信用代码已被注册"));
              } else {
                callback();
              }
            }, trigger: "blur" }
        ],
        messageCode:[
          { required: true, message: "请输入短信验证码", trigger: "blur" },
          { pattern: /^\d{6}$/, message: "短信验证码应为6位数字", trigger: "blur" }
        ],
      },
      sjformRules: {
        sjh: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确格式的手机号",
            trigger: "blur"
          },
          { min: 1, max: 15, message: "最多可输入15个数字", trigger: "blur" }
        ],
        yzm: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      },

      //用户名手机号验证码获取按钮
      usnameBtnDisable: false,
      //按钮文字
      unMsgCodeText:"获取验证码",
      tipsDialogVisible: false,
    };
  },
 
  mounted: function() {
    this.getXzqhDataTree();
  
  },
  methods: {
    //行政区划级联选择数据
    getXzqhDataTree: function() {
      let vm = this;
      vm.$axios.post("/codelist/getYjdz").then(
        function(res) {
          vm.xzqhDataTree = res.data.result;
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },

    

      //手机修改验证
    openSjYz: function() {
      this.dialogSjFormVisible = true;
    },
    //关闭手机验证对话
    closeDialog: function() {
      this.dialogSjFormVisible = false;
      this.sjform.sjh = "";
      this.sjform.yzm = "";
      this.$refs["sjform"].resetFields();
    },
    //获取短信验证码
    getMessageCode: function() {
      let vm = this;
      vm.sjform.yzm = "";
      if (/^1[3456789]\d{9}$/.test(vm.sjform.sjh)) {
        vm.messageCodeText = "发送中...";
        //$("#mobile-btn").attr("disabled", "disabled");
        this.mobileBtnDisable = true;

        //modify by yushch 260409
      
          let params={
          sjhm: vm.sjform.sjh,
          dxlx: "XGLXR"
        }
        vm.$axios.post('/signin/sendMessage2',params).then(
          function(res) {
            if (res.data.code == '00000000') {
             // vm.messageCodeReal = res.data.msg;
              var count = vm.time;
              vm.timer = setInterval(() => {
                if (count == 0) {
                  clearInterval(vm.timer);
                  vm.timer = null;
                  vm.messageCodeText = "获取验证码";
                  //  $("#mobile-btn").removeAttr("disabled");
                  this.mobileBtnDisable = false;
                } else {
                  vm.messageCodeText = count + "秒后获取";
                  count--;
                  //$("#mobile-btn").attr("disabled", "disabled");
                  this.mobileBtnDisable = true;
                }
              }, 1000);
            }else{
              this.$message.error(res.data.msg);
              vm.messageCodeText = "获取验证码";
              vm.mobileBtnDisable = false;
            }
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      }
    },
    //手机验证码form提交
    sjformSubmit: function(formName) {
      let vm=this;
      if (this.sjform.sjh != null && this.sjform.sjh != "") {
       
        //后台校验验证码
        let params = {
            sjhm: this.sjform.sjh,
            yzm: this.sjform.yzm,
            dxlx: "XGLXR"
          }
          vm.$axios.post('/dx/checkCode', params).then(function(res) {
            if (res.data.code == '00000000') {
              this.baseInforForm.lxrsj = this.sjform.sjh;
              this.dialogSjFormVisible = false;
            } else {
              vm.$message.error(res.data.msg);
            }
          }.bind(vm), function(error) {
            console.log(error);
          });
      } else {
        this.$message({
          message: "请输入手机号",
          type: "error"
        });
      }
    },
    //邮箱验证表单提交
    yxformSubmit: function() {
     
      //后台校验验证码
      let vm = this;
      let params = {
        sjhm: vm.baseInforForm.dzyx1,
        yzm: vm.yxform.yzm,
        dxlx: "YXYZ"
      }
      vm.$axios.post('/dx/checkCode', params).then(function(res) {
        if (res.data.code == '00000000') {
          this.mailCheck = true;
          this.checkedMailAddress = this.baseInforForm.dzyx1;
          this.dialogYxFormVisible = false;
          this.$message({
            message: "邮箱验证成功",
            type: "success"
          });
          this.mailCodeText = "验证";
        } else {
          this.$message({
            message: "验证码错误",
            type: "error"
          });
        }
      }.bind(vm), function(error) {
        console.log(error);
      });
    },
    //邮箱修改验证
    openYxYz: function() {
      let vm = this;
      if(vm.baseInforForm.dzyx1 !=null && vm.baseInforForm.dzyx1 !='' && vm.baseInforForm.dzyx1 !=undefined){
        //查询邮箱是否注册
      vm.$axios.get("/qyjbxx/getMailNum/" + vm.baseInforForm.dzyx1 + "/static")
          .then(
            function(res) {
              //session失效
              if (res.data.result == undefined) {
                vm
                  .$confirm("用户登陆超时，请重新登陆。", "提示", {
                    confirmButtonText: "是",
                    cancelButtonText: "否",
                    type: "warning"
                  })
                  .then(() => {
                    window.location.href = "/templates/login.html";
                  })
                  .catch(() => {});
              } else if (res.data.result == 0) {
                vm.mailCodeText = "发送中...";
         
                vm.mailBtnDisable = true;

                let params={
                  sjhm: vm.baseInforForm.dzyx1,
                  dxlx: "YXYZ"
                }
             
              vm.$axios.post("/signin/sendMail2",params).then(
                    function(res) {
                      if (res.data.code == '00000000') {
                       // vm.mailCodeReal = res.data.msg;
                        var count = vm.time2;
                        vm.timer2 = setInterval(() => {
                          if (count == 0) {
                            clearInterval(vm.timer2);
                            vm.timer2 = null;
                            vm.mailCodeText = "验证";
              
                            this.mailBtnDisable = false;
                          } else {
                            vm.mailCodeText = count + "秒后获取";
                            count--;
                        
                            vm.mailBtnDisable = true;
                          }
                        }, 1000);
                        vm.dialogYxFormVisible = true;
                      }else{
                        this.$message.error(res.data.msg);
                        vm.mailCodeText = "验证";
                        vm.mailBtnDisable = false;
                      }
                    }.bind(vm),
                    function(error) {
                      console.log(error);
                    }
                  );
              } else if (vm.baseInforForm.dzyx1 == vm.baseInforForm.dzyx) {
                vm.$message({
                  message: "此邮箱已通过验证",
                  type: "success"
                });
                return false;
              } else {
                vm.$message({
                  message: "此邮箱已被注册,请更换邮箱",
                  type: "warning"
                });
                return false;
              }
            }.bind(vm),
            function(error) {
              console.log(error);
            }
          );
      }
      

    },

    //关闭邮箱验证对话
    closeYxDialog: function() {
      this.dialogYxFormVisible = false;
      //this.yxform.yx = "";
      this.yxform.yzm = "";
      this.$refs["yxform"].resetFields();
    },
    //邮箱change判断需不需要重新验证
    dzyxChange: function() {
      if (
        this.checkedMailAddress != this.baseInforForm.dzyx1 &&
        this.checkedMailAddress != ""
      ) {
        this.mailCheck = false;
      }
    },

    //基本信息提交（下一步）
    submitJbxx: function(formName) {
      let vm = this;
      vm.$refs[formName].validate(valid => {
        if (valid) {
            // 统一社会信用代码唯一性校验：若失焦查重已标记为已注册，则拦截提交
            if (vm.tyshxydmAlertFlag2) {
              vm.$message({
                message: "统一社会信用代码已被注册，请更换后重试",
                type: "warning"
              });
              console.log("统一社会信用代码已注册，拦截提交");
              return false;
            }
            //新增
            if (vm.baseInforForm.dzyx1 != null 
                && vm.baseInforForm.dzyx1 != ""
                && vm.baseInforForm.dzyx1 != undefined 
                && vm.mailCheck == false)
            {
              vm.$message({
                message: "请对修改后的邮箱进行验证",
                type: "warning"
              });
              console.log("error submit!!");
              return false;
            } 
            else if(vm.baseInforForm.frdbdh == vm.baseInforForm.lxrsj){
              vm.$message({
                message: "备用联系人手机号不能与联系人手机号相同",
                type: "warning"
              });
              console.log("error submit!!");
              return false;
            }else {
              vm.loading = true;
              var qyjbxxVO = {
                zwgsmc: vm.baseInforForm.zwgsmc,
                ywgsmc: vm.baseInforForm.ywgsmc,
                frdb: vm.baseInforForm.frdb,
                frdbdh: vm.baseInforForm.frdbdh,
                yjdzsheng: vm.baseInforForm.xzqh[0],
                yjdzshi: vm.baseInforForm.xzqh[1],
                yjdzxx: vm.baseInforForm.yjdzxx,
                cz: vm.baseInforForm.cz,
                lxr: vm.baseInforForm.lxr,
                lxrsj: vm.baseInforForm.lxrsj,
                wz: vm.baseInforForm.wz,
                dzyx: vm.baseInforForm.dzyx1,
                sjzt: "01", //编辑中
                deleteFlag: "N",
                yyzzgs: vm.baseInforForm.yyzzgs,
                gsjc: vm.baseInforForm.gsjc,
                ywgsjc: vm.baseInforForm.ywgsjc,
              //  validateFlag: 'F'
              };
              if(vm.baseInforForm.bgdhfjh == "" || vm.baseInforForm.bgdhfjh == null || vm.baseInforForm.bgdhfjh == undefined){
                qyjbxxVO.bgdh = vm.baseInforForm.bgdh;
              }else{
                qyjbxxVO.bgdh = vm.baseInforForm.bgdh + "分机号" + vm.baseInforForm.bgdhfjh;
              }
              var obj = document.getElementById("ShengShiCascader");
              var text = obj.textContent.replace(/\s/gi, ""); // 选中文本
              var gsdz = text + vm.baseInforForm.yjdzxx;
              var qykpxxVO = {
                kpgsmc: vm.baseInforForm.zwgsmc,
                tyshxydm: vm.baseInforForm.REAunscid,
                gsdz: gsdz
              };
              var params = {
                username: vm.baseInforForm.username,
                password: vm.baseInforForm.password,
                yzm: vm.baseInforForm.messageCode, //add by yushch 20260825 在提交注册信息时再校验一次首页的注册验证码，防止接口往里灌数据的现象发生
                usertype: "CHN",
                deptid: "ZSYH",
                qyjbxxVO: qyjbxxVO,
                qykpxxVO: qykpxxVO
              };
              vm.$axios.post("/signin/insertByVO", params).then(
                function(res) {
                  if (res.data.result != null && res.data.result != "") {
                    this.$message({
                      type: "success",
                      message: "注册成功！"
                    });
                    vm.tipsDialogVisible=true;
                    // 通知 login 父页面关闭企业基本信息弹窗
                    vm.$emit('close');
                    
                  }else{
                    vm.$message({
                      message: res.data.msg,
                      type: "error"
                    });
                    vm.loading = false;
                  }
                }.bind(vm),
                function(error) {
                  console.log(error);
                }
              );
            }
          
        } else {
          setTimeout(() => {
              var isError = document.getElementsByClassName("is-error");
              isError[0].querySelector('input,textarea').focus();
            }, 100);
          console.log("error submit!!");
          return false;
        }
      });
    },

    //获取短信验证码
    getUserNameMsgCode: function() {
      let vm = this;
      if (/^1[3456789]\d{9}$/.test(vm.baseInforForm.username)) {
        vm.unMsgCodeText = "发送中...";
        this.usnameBtnDisable = true;
          let params={
          sjhm: vm.baseInforForm.username,
          dxlx: "ZC"
        }
        vm.$axios.post('/signin/sendMessage2',params).then(
          function(res) {
            if (res.data.code == '00000000') {
              var count = vm.time;
              vm.timer = setInterval(() => {
                if (count == 0) {
                  clearInterval(vm.timer);
                  vm.timer = null;
                  vm.unMsgCodeText = "获取验证码";
                  this.usnameBtnDisable = false;
                } else {
                  vm.unMsgCodeText = count + "秒后获取";
                  count--;
                  this.usnameBtnDisable = true;
                }
              }, 1000);
            }else{
              this.$message.error(res.data.msg);
              vm.unMsgCodeText = "获取验证码";
              vm.usnameBtnDisable = false;
            }
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      }
    },
    //默认联系人手机号是用户名
    usnameChange: function(){
      this.baseInforForm.lxrsj = this.baseInforForm.username;
    },
    closeTipsDialog: function(){
      this.tipsDialogVisible = false;
    },
    // 统一社会信用代码唯一性校验（查重）
    tyshxydmCheck: function(){
      let vm = this;
      let tyshxydm = (vm.baseInforForm.REAunscid || "").replace(/ /g, "");
      if (!tyshxydm) {
        // 未填写时不拦截，必填由 rules 控制
        vm.tyshxydmAlertFlag2 = false;
        return;
      }
      // 先校验格式合规：18位且只能包含数字和字母，不合规则提示且不走后台
      if (tyshxydm.length !== 18 || !/^[0-9a-zA-Z]+$/.test(tyshxydm)) {
        //不合规不拦截，由 rules 控制
        vm.tyshxydmAlertFlag2 = false;
        return;
      }
      vm.$axios.get("/signin/isTyshxydmUsed/"+ tyshxydm).then(
        function(res) {
          if (res.data.result && res.data.result > 0) {
            // 该统一社会信用代码已被注册，弹窗提示并允许去重置账户
            vm.$confirm('统一社会信用代码已被注册，请通过手机号直接登录。<br>如忘记手机号，可通过重置账户功能重置，<br>是否立即重置？', '提示', {
              confirmButtonText: '去重置',
              cancelButtonText: '取消',
              type: 'warning',
              dangerouslyUseHTMLString: true
            }).then(() => {
              // 重置账户页面跳转
              vm.$router.push({
                path: "/exhibition/login/ch/Reset"
              });
            }).catch(() => {
              vm.$message({
                type: 'info',
                message: '已取消'
              });
            });
            vm.tyshxydmAlertFlag2 = true;
          } else {
            vm.tyshxydmAlertFlag2 = false;
          }
          vm.$refs.baseInforForm.validateField('REAunscid')
        }.bind(vm),
        function() {
          vm.tyshxydmAlertFlag2 = false;
          vm.$refs.baseInforForm.validateField('REAunscid')
        }
      );
    }
  }
};
</script>

<style lang="scss">
#registerBaseInfo {
  .mb5 {
    margin-bottom: 5px;
  }
  .el-form-item__content .el-input,
  .el-form-item__content .el-input-group {
    vertical-align: middle;
  }
   .el-card__body {
    padding: 10px 0px 10px 0px;
  }
  .el-message {
    z-index: 10005 !important;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #2452ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .el-dialog {
    width: 45%;
  }
  .el-button--small {
    padding: 9px 9px;
  }
  .card_title_font{
    line-height: 40px;
  }
  .clearfix{
    height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhprediction/exhpredictionEdit/RegisterBaseInfo.vue